import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 656.25 647.25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "329.494",
      cy: "326.324",
      r: "309.513",
      fill: "none",
      stroke: "#FAA918",
      "stroke-miterlimit": "10",
      "stroke-width": "19"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FAA918",
      d: "M392.202 323.556c-41.4 26.4-49.201 44.4-49.201 93.602h-31.2c0-62.401 15.6-86.401 67.201-121.202 28.801-19.2 43.201-44.4 43.201-77.401 0-49.8-36.001-81.001-87.001-81.001-61.801 0-97.201 34.201-97.201 95.401h-33c0-76.801 52.801-126.001 130.202-126.001 36 0 68.4 13.2 90.001 35.4 18.6 19.8 30.6 43.8 30.6 74.401-.001 49.8-26.402 82.801-63.602 106.801m-88.201 218.402v-46.801h47.4v46.801z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "questmark-404"}) } }